module.exports = __webpack_public_path__ + "static/media/48.fb0b5b9e.jpg";